import { combineReducers } from 'redux';

import appReducer from 'redux/reducers/app.reducer';
import authReducer from 'redux/reducers/auth.reducer';
import blocksReducer from 'redux/reducers/blocks.reducer';
import categoryPricesReducer from 'redux/reducers/categoryPrices.reducer';
import cementeriesReducer from 'redux/reducers/cementeries.reducer';
import divorcesReducer from 'redux/reducers/divorces.reducer';
import deathsReducer from 'redux/reducers/deaths.reducer';
import documentsReducer from 'redux/reducers/documents.reducer';
import documentsTypesReducer from 'redux/reducers/documentsTypes.reducer';
import gravesReducer from 'redux/reducers/graves.reducer';
import jewishnessReducer from 'redux/reducers/jewishness.reducer';
import marriagesReducer from 'redux/reducers/marriages.reducer';
import matzevaReducer from 'redux/reducers/matzeva.reducer';
import permissionsReducer from 'redux/reducers/permissions.reducer';
import personsReducer from 'redux/reducers/persons.reducer';
import proceduresReducer from 'redux/reducers/procedures.reducer';
import proceduresEmailsReducer from 'redux/reducers/proceduresEmails.reducer';
import rolesReducer from 'redux/reducers/roles.reducer';
import reservationsReducer from 'redux/reducers/reservations.reducer';
import usersReducer from 'redux/reducers/users.reducer';

const rootReducer = combineReducers({
  app: appReducer,
  auth: authReducer,
  blocks: blocksReducer,
  categoryPrices: categoryPricesReducer,
  cementeries: cementeriesReducer,
  divorces: divorcesReducer,
  deaths: deathsReducer,
  documents: documentsReducer,
  documentsTypes: documentsTypesReducer,
  graves: gravesReducer,
  jewishness: jewishnessReducer,
  marriages: marriagesReducer,
  matzeva: matzevaReducer,
  permissions: permissionsReducer,
  persons: personsReducer,
  procedures: proceduresReducer,
  proceduresEmails: proceduresEmailsReducer,
  roles: rolesReducer,
  reservations: reservationsReducer,
  users: usersReducer,
});

export default rootReducer;
